import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Spin,
} from "antd";
import React from "react";
import ItemsService from "../../Services/ItemsService";
import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { dayjs } from "../../../Utilities/dayjs";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/Routing/PageRoute";
import { useLocation } from "react-router-dom";

const AddSerialNoModal: React.FC<{
  open: boolean;
  onCancel: any;
  setSerialNoData: (param: any) => void;
  id?: string | undefined;
  serialNoData?: any;
  setInInvoice?: (param: any) => void;
  allSerialData?: any;
  setAllSerialData: (param: any) => void;
}> = (props) => {
  const [form] = Form.useForm();
  const { openNotification } = React.useContext(notificationContext);
  const location = useLocation();
  const { currentClient } = useClient();
  const [data, setData] = React.useState<any[]>([]);
  const [serialDetails, setSerialDetails] = React.useState<any[]>([]);
  const [triger, setTriger] = React.useState<boolean>(false);
  const [searchVal, setSearchVal] = React.useState<any>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [checkedItems, setCheckedItems] = React.useState<any[]>([]);
  const [btnLoading, setBtnLoading] = React.useState(false);
  const handleValuesChange = (changedValues: any, allValues: any) => {
    const batches = allValues.seriolNo;
    setData(batches);
  };
  React.useEffect(() => {
    if (props?.serialNoData?.length > 0) {
      setLoading(true);
      form.setFieldsValue({
        seriolNo: props?.serialNoData?.map((d: any) => ({
          modalNo: d?.modalNo,
          warranty: d?.warranty ? dayjs(d?.warranty) : "",
          serialNumber: d?.serialNumber,
          // status: BatchItemStatus[d?.status],
        })),
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [props?.serialNoData, form]);

  console.log("iteeem", props?.serialNoData);

  React.useEffect(() => {
    const getData = async () => {
      // if (res?.result) {
      const matchItems = props?.allSerialData ?? props?.serialNoData;
      setSerialDetails(matchItems);
      console.log("itm", matchItems);
      if (matchItems && matchItems.length > 0) {
        form.setFieldsValue({
          seriolNo: matchItems
            // .filter((d: any) => d.baseType === 0)
            .map((d: any) => ({
              modalNo: d?.modalNo,
              warranty: dayjs(d?.warranty),
              serialNumber: d?.serialNumber,
              // status: BatchItemStatus[d?.status],
            })),
        });
      }
      // setLoading(false);
    };
    getData();
  }, [currentClient?.id, props?.id, form, triger]);

  console.log("val", searchVal);

  const handleAddSerialNumber = async () => {
    setBtnLoading(true);
    if (
      serialDetails &&
      serialDetails.some((item: any) => item.serialNumber === searchVal)
    ) {
      openNotification("error", "Serial No already exists");
      setBtnLoading(false);
      setSearchVal("");
      return;
    }

    const isSerialExists = await ItemsService.getSerialNo(
      currentClient?.id,
      searchVal
    ).then((x) => x.result);

    if (isSerialExists) {
      openNotification("error", "Serial No already exist");
      setBtnLoading(false);
      setSearchVal("");
      return;
    }

    if (searchVal) {
      const newEntry = {
        serialNumber: searchVal,
        warranty: dayjs() || null,
      };

      const existingList = form.getFieldValue("seriolNo") || [];
      const updatedList = [{ ...newEntry }, ...existingList];

      setSerialDetails(updatedList);

      form.setFieldsValue({
        seriolNo: updatedList.map((d: any, index: number) => ({
          serialNumber: d?.serialNumber || "",
          modalNo: existingList[index]?.modalNo ?? "",
          warranty: dayjs(d?.warranty),
        })),
      });
      setBtnLoading(false);
      setSearchVal("");
      setData(updatedList);
    }
  };

  const saveData = () => {
    if (Array.isArray(data) && data.length > 0) {
      // props?.setSerialNoData(data);
    } else {
      // props?.setSerialNoData(props?.serialNoData);
    }
    const existingList = form.getFieldValue("seriolNo") || [];
    props?.setAllSerialData(existingList);
    console.log("existingListtt", existingList);
    props?.onCancel(false);
  };

  const handleCheckboxChange = (
    checked: boolean,
    field: any,
    fields: any[]
  ) => {
    const allData = form.getFieldValue("seriolNo") || [];
    const updatedData = [...allData];
    if (checked) {
      setCheckedItems((prevData) => [...prevData, updatedData[field.name]]);
    } else {
      setCheckedItems((prevData) =>
        prevData.filter((item) => item.key !== updatedData[field.name].key)
      );
    }
  };

  const handleSave = () => {
    props?.setInInvoice && props?.setInInvoice(checkedItems);
    props?.onCancel(false);
    console.log("Saved Data:", checkedItems);
  };

  console.log("checkeddata", checkedItems);

  return (
    <div>
      <Modal
        width={800}
        onCancel={() => props?.onCancel(false)}
        open={props?.open}
        title="Opening Stock - Serial No."
        footer={
          <>
            <Row gutter={12} justify={"end"}>
              <Col>
                <Button onClick={() => props.onCancel(false)}>Cancel</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  disabled={
                    props?.serialNoData?.length > 0 ||
                    data?.length > 0 ||
                    serialDetails.length > 0
                      ? false
                      : true
                  }
                  onClick={
                    location.pathname.split("/")[4] === "sales" ||
                    location.pathname.split("/")[4] === "purchase"
                      ? handleSave
                      : saveData
                  }
                >
                  {location.pathname.split("/")[4] === "sales" ||
                  location.pathname.split("/")[4] === "purchase"
                    ? "Done"
                    : "Save"}
                </Button>
              </Col>
            </Row>
          </>
        }
      >
        <>
          <Row style={{ margin: "20px 0px 15px 0px" }}>
            <Col>
              {props?.id ? (
                <></>
              ) : (
                <>
                  <Form.Item label="Enter Serial No." className="m-0">
                    <Input
                      style={{ width: "300px" }}
                      value={searchVal}
                      onChange={(e) => setSearchVal(e.target.value)}
                      maxLength={20}
                      className="input"
                      addonAfter={
                        <>
                          <Button
                            onClick={handleAddSerialNumber}
                            size="small"
                            loading={btnLoading}
                            style={{
                              cursor: "pointer",
                              border: "none",
                              paddingTop: "16px",
                              paddingBottom: "14px",
                            }}
                            disabled={!searchVal ? true : false}
                          >
                            <PlusOutlined />
                          </Button>
                        </>
                      }
                    />
                  </Form.Item>
                </>
              )}
            </Col>
          </Row>
          <Form
            form={form}
            // initialValues={{
            //   seriolNo: [{}],
            // }}
            onValuesChange={handleValuesChange}
            style={{ maxHeight: "60vh", overflowY: "scroll" }}
          >
            <Spin spinning={loading} indicator={<LoadingOutlined />}>
              <table className="AddPageTabelDesign" style={{ width: "100%" }}>
                {(props?.serialNoData?.length > 0 ||
                  data?.length > 0 ||
                  serialDetails.length > 0) && (
                  <>
                    <thead>
                      <tr>
                        {location.pathname.split("/")[4] === "sales" ? (
                          <th>Select</th>
                        ) : (
                          ""
                        )}
                        <th>Serial No.</th>
                        <th>Modal No.</th>
                        <th>Warranty Date</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                  </>
                )}
                <tbody>
                  <Form.List name="seriolNo">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((field, name) => (
                          <tr key={field.key}>
                            {location.pathname.split("/")[4] === "sales" ? (
                              <>
                                <td style={{ textAlign: "center" }}>
                                  <Form.Item
                                    name={[field.name, "check"]}
                                    valuePropName="checked"
                                    className="m-0"
                                  >
                                    <Checkbox
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e.target.checked,
                                          field,
                                          fields
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </td>
                              </>
                            ) : (
                              ""
                            )}

                            <td>
                              <Form.Item
                                name={[name, "serialNumber"]}
                                className="m-0"
                              >
                                <Input
                                  placeholder="Serial Number"
                                  disabled
                                  maxLength={30}
                                />
                              </Form.Item>
                            </td>
                            <td style={{ width: "30%" }}>
                              <Form.Item
                                name={[name, "modalNo"]}
                                className="m-0"
                              >
                                <Input
                                  placeholder="Modal Number"
                                  maxLength={30}
                                  type="tel"
                                />
                              </Form.Item>
                            </td>
                            <td>
                              <Form.Item
                                name={[name, "warranty"]}
                                className="m-0"
                              >
                                <DatePicker
                                  placeholder="Warranty Date"
                                  style={{ width: "100%" }}
                                  format={"DD/MM/YYYY"}
                                  disabledDate={(current) =>
                                    current <
                                    dayjs("1900-01-01", "YYYY-MM-DD").add(
                                      -1,
                                      "day"
                                    )
                                  }
                                />
                              </Form.Item>
                            </td>
                            {/* 
                          <td>
                            <Form.Item name={[name, "status"]} className="m-0">
                              <Select
                                style={{ width: "140px" }}
                                options={[
                                  {
                                    value: BatchItemStatus.Available,
                                    label: "Available",
                                  },
                                  {
                                    value: BatchItemStatus.Sold,
                                    label: "Sold",
                                  },
                                  {
                                    value: BatchItemStatus.Expired,
                                    label: "Expired",
                                  },
                                  {
                                    value: BatchItemStatus.Damaged,
                                    label: "Damaged",
                                  },
                                  {
                                    value: BatchItemStatus.Returned,
                                    label: "Returned",
                                  },
                                ]}
                              />
                            </Form.Item>
                          </td> */}
                            <td>
                              <Button
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => remove(field.name)}
                              />
                            </td>
                          </tr>
                        ))}
                        {/* <Row gutter={15} style={{ marginTop: "10px" }}>
                        <Col>
                          <Button
                            type="primary"
                            size="small"
                            icon={<PlusOutlined />}
                            onClick={() => add(fields.length + 1)}
                          >
                            Add
                          </Button>
                        </Col>
                      </Row> */}
                      </>
                    )}
                  </Form.List>
                </tbody>
              </table>
            </Spin>
          </Form>
        </>
      </Modal>
    </div>
  );
};

export default AddSerialNoModal;
